import './post_a_shipment.less'
import React, {PropTypes} from 'react';
import LogoutPopUp from '../components/logoutPopUp/logout_pop_up';
import CONSTANTS from '../common_constants';
import {Link, browserHistory} from 'react-router';
import DashBoardHeader from '../header_dashboard/dashboard_header';
import dashboardActions from '../dashboard/dashboard_actions';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import authActions from '../auth/auth_actions';

class PostAShipment extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const self = this;
    const {props, state} = this;
    let sessionValid = true ;

    if("sessionValid" in props.authState.userData)
        sessionValid = props.authState.userData.sessionValid

    let user = {
      name: '',
      imageUrl: '',
      isVerified: ''
    };

    if(props.authState) {
      user.name = props.authState.userData.name;
      user.imageUrl = props.authState.userData.profileImageUrl;
      user.isVerified = props.authState.userData.isVerified;
    }

    return (
      <div className = "post-a-shipment-wrap">
        <DashBoardHeader user = {user} logout={this.logout}/>
          <div className = "d-header-wrap">
            <div className = "wrapper">
              <h2 className = "page-header d-page-header">Post a Shipment</h2>
            </div>
          </div>
          {this.props.children}
      </div>
    )
  }
}


PostAShipment = connect((state) => {
  return {
    dashboard: state.app.dashboard,
    authState: state.app.auth
  }
}, (dispatch) => {
  return {
    dashboardActions: bindActionCreators(dashboardActions, dispatch),
    routerActions: bindActionCreators(routerActions, dispatch),
    authActions : bindActionCreators(authActions, dispatch)
  }
})(PostAShipment);

export default PostAShipment;



// WEBPACK FOOTER //
// app/post_a_shipment/post_a_shipment.jsx